import {Map} from "@luciad/ria/view/Map";
import React from "react";
import {useMapContext} from "../../hooks/useMapContext";
import {Attribution} from "./Attribution";
import {BottomLeftOverlay} from "./BottomLeftOverlay";
import "./DefaultMapOverlays.css";
import {HereSearchBar} from "./HereSearchBar";
import {LayerTreeControl} from "./LayerTreeControl";
import {MouseCoordinateReadout} from "./MouseCoordinateReadout";
import {ScaleIndicator} from "./ScaleIndicator";
import {TopLeftButtons} from "./TopLeftButtons";

interface Props {
  topLeftButtons?: ((map: Map) => JSX.Element) | null;
  mouseCoordinateReadout?: ((map: Map) => JSX.Element) | null;
  searchBar?: ((map: Map) => JSX.Element) | null;
  layerTreeControl?: ((map: Map) => JSX.Element) | null;
  scaleIndicator?: ((map: Map) => JSX.Element) | null;
  attribution?: ((map: Map) => JSX.Element) | null;
  extraOverlay?: ((map: Map) => JSX.Element);
  customControl?: (map: Map) => JSX.Element;
  bottomLeftOverlay?: ((map: Map) => JSX.Element) | null;
}

export const OVERLAY_CLASSNAME = "map-overlay";
export const OVERLAY_CONTROL_CLASSNAME = "overlay-control";

export const DefaultMapOverlays = ({
                                     topLeftButtons = (map) => <TopLeftButtons map={map}/>,
                                     mouseCoordinateReadout = (map) => <MouseCoordinateReadout
                                         map={map}/>,
                                     searchBar = (map) => <HereSearchBar map={map}/>,
                                     layerTreeControl = (map) => <LayerTreeControl map={map}/>,
                                     scaleIndicator = (map) => <ScaleIndicator map={map}/>,
                                     attribution = (map) => <Attribution map={map}/>,
                                     extraOverlay,
                                     customControl,
                                     bottomLeftOverlay = (map) => <BottomLeftOverlay map={map}/>,
                                   }: Props) => {
  const {map} = useMapContext();

  return (
      <div className={OVERLAY_CLASSNAME}>
        {topLeftButtons && topLeftButtons(map)}
        {mouseCoordinateReadout && mouseCoordinateReadout(map)}
        {scaleIndicator && scaleIndicator(map)}
        <div className={OVERLAY_CONTROL_CLASSNAME}>
          {searchBar && searchBar(map)}
          {layerTreeControl && layerTreeControl(map)}
          {customControl && customControl(map)}
        </div>
        {attribution && attribution(map)}
        {extraOverlay && extraOverlay(map)}
        {bottomLeftOverlay && bottomLeftOverlay(map)}
      </div>
  )
}